import React from 'react'
import {
  CFImage,
  CFView,
  CFText,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'
import ViewMenuButton from './ViewMenuButton'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="105vh"
          maxHeight="720px"
          w="100%"
          image={`url(${mobileHero}) center / cover no-repeat`}
          column
          justifyStart
          alignCenter
        >
          <CFView style={{ fontSize: 34 }} white xBold textCenter mt="35px">
            Welcome to
          </CFView>
          <CFView
            style={{ fontSize: 34, color: 'red' }}
            xBold
            textCenter
            m="5px"
          >
            Gates Park Cafe
          </CFView>
          <CFView
            style={{ fontSize: 34 }}
            white
            xBold
            textCenter
            m="5px"
            mb="20px"
          >
            in Port Coquitlam!
          </CFView>
          <CFView pulsate mb="30px" textCenter>
            <OrderPickupButton />
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="700px"
          w="100%"
          image={`url(${hero}) top / cover no-repeat`}
          zIndex={90}
          column
          justifyBetween
          alignCenter
        >
          <Header />
          <CFView column center bg="rgba(0,0,0,0.85)" ph="50px" pv="5px">
            <CFView row center>
              <CFView bold white style={{ fontSize: 31 }}>
                Hens Up Chicken Gates Park Cafe
              </CFView>
              <CFView ml="30px" pulsate>
                <OrderPickupButton />
              </CFView>
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
